import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { UserEntity } from "../../../api/Users/Entity/UserEntity";
import { useEffect, useState } from "react";
import { UpdateUserDto } from "../../../api/Users/Dto/UpdateUserDto";
import { RoleEntity } from "../../../api/Role/Entity/RoleEntity";
import ConfirmationDialog from "../../../shared/Components/ConfirmationDialog";

interface Props {
  isOpen: boolean;
  onSubmit(data: UpdateUserDto): void;
  onClose(): void;
  defaultValue: UserEntity;
  roleList: RoleEntity[];
}

export function EditUserDialog({
  isOpen,
  onSubmit,
  onClose,
  defaultValue,
  roleList,
}: Props) {
  const [roleId, setRoleId] = useState("");
  const [status, setStatus] = useState("");
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  useEffect(() => {
    setRoleId(defaultValue.roleId);
    setStatus(defaultValue.status ? "Active" : "Inactive");
  }, [defaultValue]);
  return (
    <>
      <ConfirmationDialog
        description="Are you sure you want to save the changes?"
        onCancel={() => setConfirmationDialog(false)}
        onClose={() => setConfirmationDialog(false)}
        open={confirmationDialog}
        onSubmit={() => {
          onSubmit({
            binusianId: defaultValue.binusianId,
            roleId,
            isActive: status == "Active",
          });
          setConfirmationDialog(false);
        }}
      />
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="font-bold">
          {`${defaultValue.name} - ${defaultValue.binusianId}`}
        </DialogTitle>
        <DialogContent className="flex flex-col gap-5">
          <FormControl>
            <Box className="flex gap-2">
              <Typography className="font-bold">Role Name</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Select
              value={roleId}
              onChange={(e) => setRoleId(e.target.value)}
              className="bg-white border-2 border-gray-300"
            >
              {roleList.map((e) => (
                <MenuItem value={e.id}>{e.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <Box className="flex gap-2">
              <Typography className="font-bold">Status</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="bg-white border-2 border-gray-300"
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions className="flex justify-center">
          <Button onClick={onClose} variant="contained" color="error">
            Cancel
          </Button>
          <Button
            onClick={() => setConfirmationDialog(true)}
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
